import { FeatureVisibility } from '@snap-types/models/enums';

export function isFeatureVisibleToUser(
  featureVisibility: FeatureVisibility,
  isSuperAdmin: boolean,
) {
  switch (featureVisibility) {
    case FeatureVisibility.NONE:
      return false;
    case FeatureVisibility.SUPER_ADMIN:
      return isSuperAdmin;
    case FeatureVisibility.ALL:
      return true;
  }
}
